import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    // Primary brand colors
    primary: {
      50: '#E8F3FA',
      100: '#C5E0F2',
      200: '#9ECCEA',
      300: '#77B7E1',
      400: '#4A9FD0',
      500: '#0A70B9', // Main brand blue
      600: '#085E9E',
      700: '#064B80',
      800: '#043962',
      900: '#022644',
    },
    secondary: {
      50: '#F0FAFC',
      100: '#DCF2F8',
      200: '#C4E8F2',
      300: '#A8DCEB',
      400: '#92D3E6',
      500: '#7BC6DB',
      600: '#5BB0CA',
      700: '#4294AD',
      800: '#35788F',
      900: '#2A5F73',
    },
    // Semantic colors for data states
    accent: {
      success: '#10B981',
      warning: '#F59E0B',
      danger: '#EF4444',
      info: '#3B82F6',
      purple: '#8B5CF6',
    },
    // Enhanced neutral grays
    gray: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937', // Dark mode surface
      900: '#111827', // Dark mode background
    },
    // Sports-specific accents
    sports: {
      nfl: '#013369',
      nba: '#C8102E',
      mlb: '#132448',
      nhl: '#000000',
      cfb: '#8B0000',
      cbb: '#003366',
    },
    ui: {
      main: '#0A70B9',
      secondary: '#7BC6DB',
      success: '#10B981',
      danger: '#EF4444',
      light: '#FAFAFA',
      dark: '#1A202C',
      darkSlate: '#252D3D',
      dim: '#A0AEC0',
    },
  },
  fonts: {
    heading:
      '"Big Shoulders", "Inter", "SF Pro Display", system-ui, sans-serif',
    body: '"Inter", "SF Pro Text", system-ui, sans-serif',
    mono: '"JetBrains Mono", "Fira Code", monospace',
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  sizes: {
    container: {
      sm: '640px',
      md: '768px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px',
      content: '1200px',
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          backgroundColor: 'primary.500',
          color: 'white',
          fontWeight: 'semibold',
          borderRadius: '8px',
          px: 6,
          py: 3,
          _hover: {
            backgroundColor: 'primary.600',
            transform: 'translateY(-1px)',
            boxShadow: 'md',
          },
          _active: {
            transform: 'translateY(0)',
          },
        },
        outline: {
          border: '2px solid',
          borderColor: 'primary.500',
          color: 'primary.500',
          _hover: {
            bg: 'primary.900',
          },
        },
        ghost: {
          color: 'gray.300',
          _hover: {
            bg: 'gray.800',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'gray.800',
        },
        header: {
          bg: 'transparent',
        },
        body: {
          bg: 'transparent',
        },
        footer: {
          bg: 'transparent',
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: 'gray.900',
        color: 'gray.100',
      },
    },
  },
});

export default theme;
